import * as Sentry from '@sentry/nextjs';
import {PropsWithChildren} from 'react';
import {ErrorBoundary as ReactErrorBoundary, FallbackProps} from 'react-error-boundary';
import {ErrorState} from '@/components/blocks/error-state';
import {Card, CardContent} from './ui/card';

type ErrorBoundaryProps = PropsWithChildren<unknown>;

async function onError(error: Error, info: {componentStack: string}) {
    Sentry.configureScope((scope) => {
        scope.setExtra('componentStack', info.componentStack);
    });
    Sentry.captureException(error);
    await Sentry.flush();
}

function Fallback({resetErrorBoundary}: FallbackProps) {
    return (
        <div className="h-full w-full flex items-center justify-center">
            <Card className="bg-white w-1/2">
                <CardContent>
                    <ErrorState onRetry={resetErrorBoundary} />
                </CardContent>
            </Card>
        </div>
    );
}

export function GlobalError({children}: ErrorBoundaryProps) {
    return (
        <ReactErrorBoundary FallbackComponent={(props) => <Fallback {...props} />} onError={onError}>
            {children}
        </ReactErrorBoundary>
    );
}

GlobalError.displayName = 'GlobalError';
